<template>
  <div>
    <Dialog
      :key="permissionFormKey"
      :visible.sync="permissionsForm1"
      :style="{ width: '900px' }"
      header="permission Details"
      :modal="true"
      class="p-fluid"
    >
      <DataTable
        :value="activePermissions"
        dataKey="id"
        class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
        :selection.sync="selectedRow"
      >
        <Column selectionMode="single" headerStyle="width: 3em;"></Column>
        <Column
          field="dispOrder"
          header="No"
          headerStyle="width: 4em"
          :sortable="true"
        >
        </Column>
        <Column
          field="permissionCode"
          header="Code"
          headerStyle="width: 12em"
          :sortable="true"
        >
        </Column>
        <Column
          field="permissionDesc"
          header="Description"
          headerStyle="width: 16em"
          :sortable="true"
        >
        </Column>
        <Column
          field="permissionType"
          header="Type"
          headerStyle="width: 8em"
          :sortable="true"
        >
        </Column>
        <!-- <Column
          field="module.moduleName"
          header="Module Name"
          headerStyle="width: 12em"
          :sortable="true"
        >
        </Column> -->
        <Column
          field="fields"
          header="Fields"
          headerStyle="width: 8em"
          :sortable="true"
        >
        </Column>
      </DataTable>

      <div v-if="selectedRow">
        <p>Permission Description: {{selectedRow.permissionDesc}}</p>
        <div class="flex align_items_center">
          <p style="margin: auto 0">Permission Level:</p>
          &nbsp;
          &nbsp;
          &nbsp;
          <Dropdown
            style="width: 100%"
            :showClear="true"
            v-model="permissionLevel"
            :options="permissionLevels"
            optionLabel="value"
            dataKey="id"
            placeholder="Select from the dropdown"
          />
        </div>
      </div>
      
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <template #footer>
        <Button 
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')" 
        />
        <ProgressSpinner 
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button 
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>

    </Dialog>
  </div>
</template>

<script>
import RoleService from "@/service/RoleService";

import { sendPermission } from '../sendRequest'

export default {
  created() {
    this.setupComponent()
  },
  props: {
    role: {
      type: Object,
      required: true
    },
    permissionsForm: {
      required: true,
      type: Boolean
    },
    reloadForm: {
      required: false,
      type: Number
    },
    disabledArr: {
      required: true,
      type: Array
    },
    permissionToEdit: {
      type: Object,
      required: false
    },
    activePermissions: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    roleService: new RoleService(),
    permissionFormKey1: 0,
    submitted: false,
    sendingRequest: false,
    permission: {},
    selectedRow: [],
    permissionLevel: null,
    permissionLevels: [
      { id: 0, value: 'None' },
      { id: 1, value: 'Allow' },
      { id: 2, value: 'Allow for Fields' }
    ]
  }),
  computed: {
    permissionFormKey: {
      set(val) {
        this.permissionFormKey1++
      },
      get() {
        // 
        return 'permissionFormKey-' + this.permissionFormKey1.toString()
      }
    },
    permissionsForm1: {
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
      get() {
        return this.permissionsForm
      }
    }
  },
  watch: {
    permissionsForm(val) {
      this.permissionFormKey = this.permissionFormKey1 + 1
    },
    reloadForm(val) {
      this.setupComponent()
    }
  },
  methods: {
    setupComponent() {
      this.submitted = false
      this.sendingRequest = false
      this.permission = {}

      if (this.permissionToEdit && this.permissionToEdit.id) {
        this.permission = this.permissionToEdit
      }
    },
    save() {
      
      // 
      this.submitted = true
      this.sendingRequest = true

      console.log(this.selectedRow, this.permissionLevel)

      sendPermission(this, 'PermissionsForm.vue')
    }
  }
}
</script>

<style scoped>

</style>